<template>
  <div ref="counter">
    <div v-if="cardsAmount === 1">{{ cardsAmount }} item</div>
    <div v-else>{{ cardsAmount }} itens</div>
  </div>
</template>
          
          <script>
export default {
  name: "KanbanTaskLaneCounter",
  props: {
    cardsAmount: Number,
  },
  data: function () {
    return {
    };
  },
  destroyed() {
    this.observerCount.disconnect();
  },
  inject: ["countItems"],
  mounted() {
    this.observerCount = new IntersectionObserver(
      ([{ isIntersecting, target }]) => {
        if (isIntersecting) {
          this.countItems();
          this.observerCount.disconnect();
        }
      }
    );
    this.observerCount.observe(this.$refs.counter);
  },
  methods: {},
};
</script>